<template>
    <div>
        <div class="common-header">
            <div style="text-align: left;">
                <el-button type="primary" class="common-s-btn" @click="insertPlan">创建牛仔</el-button>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    height="100%"
                    row-key="id"
                    @selection-change="selection = $event"
                    :data="cbRoomList.beanList">
               <el-table-column  label="房间Id" align="center">
                 <template slot-scope="scope">{{scope.row.roomId}}</template>
               </el-table-column>
               <el-table-column  label="房间名称" align="center">
                 <template slot-scope="scope">{{scope.row.roomName}}</template>
               </el-table-column>
                       
               <el-table-column  label="牌局时长" align="center" >
                 <template slot-scope="scope">{{scope.row.duration+"分钟"}}</template>
               </el-table-column>
               
               <el-table-column  label="开始时间" align="center" >
                 <template slot-scope="scope">{{getLocalTime(scope.row.startTime)}}</template>
               </el-table-column>
                <el-table-column  label="最小带入" align="center" >
                 <template slot-scope="scope">{{scope.row.minBring}}</template>
               </el-table-column>
               <el-table-column  label="最大带入" align="center" >
                 <template slot-scope="scope">{{scope.row.maxBring}}</template>
               </el-table-column>
               
               <el-table-column  label="房间状态" align="center">
                 <template slot-scope="scope">{{roomStatusTr(scope.row.status)}}</template>
               </el-table-column>
                <el-table-column  label="创建时间" align="center" >
                 <template slot-scope="scope">{{getLocalTime(scope.row.createTime)}}</template>
               </el-table-column>
               
               <el-table-column  label="聊天功能" align="center">
                 <template slot-scope="scope">{{scope.row.enableChat==1?"开启":"关闭"}}</template>
               </el-table-column>
               <el-table-column  label="结束自动开房" align="center" prop="totalIntegral">
                  <template slot-scope="scope">
                       <el-button :type="buttonType(scope.row)" @click="edit(scope.row)">{{ scope.row.autoCreate==1?"开启状态":"关闭状态"}}</el-button>
                   </template>
               </el-table-column>
                                 
               <el-table-column  label="操作" align="center">
                   <template slot-scope="scope">
                       <el-button v-if="scope.row.status==1" type="primary" @click="closeRoom(scope.row,3)">提前结束</el-button>
                       <el-button v-if="scope.row.status==0" type="primary" @click="closeRoom(scope.row,1)">开始游戏</el-button>
                   </template>
				   
               </el-table-column>
			   <el-table-column  label="强制操作" align="center">
			       <template slot-scope="scope">
			           <el-button v-if="scope.row.status==1" type="danger" @click="closeRoom(scope.row,4)">强制结束</el-button>
			       </template>
			   				   
			   </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="cbRoomList.total"
                @current-change="getList($event)"
                :current-page="currentPage"/>
				
		<el-dialog title="新增牛仔牌局" :visible.sync="dialogTableVisible">
            <div style="display: flex; flex-direction: column;justify-content: center;align-items: center;">
                <el-form :inline="true" :model="form">
                <el-form-item   label="房间名称" >
                    <el-input v-model="form.roomName" autocomplete="off"></el-input>
                </el-form-item>
				<br/>
                  <el-form-item label="牌局时长(分钟)">
                    <el-slider v-model="form.duration" :step="360" :min="360" :max="1440" show-stops  >
                    </el-slider>
                </el-form-item>
				<br/>
                <el-form-item label="最小带入记分牌">
                    <el-slider v-model="form.minBring"  :step="100" :min="100" :max="1000">
                    </el-slider>
                </el-form-item>
				<br/>
                <el-form-item label="最大带入记分牌">
                    <el-slider v-model="form.maxBring" :step="100000" :min="100000" :max="5000000">
                    </el-slider>
                </el-form-item>
                <br/>
                <el-form-item label="是否开启聊天">
                    <el-switch v-model="form.enableChat" active-value="1" inactive-value="0" active-text="开启" inactive-text="关闭"> </el-switch>
                </el-form-item>
				<br/>
               <el-form-item label="结束自动开启新的牌局">
                    <el-switch v-model="form.autoCreate" active-value="1" inactive-value="0" active-text="开启" inactive-text="关闭"> </el-switch>
                </el-form-item>
            
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="subMitInsertPlan">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
				dialogTableVisible:false,
                loading: false,
                date: null,
                type: '',
                typeOptions: [
                    {label: '全部', value: ''},
                    {label: '伙牌', value: 1},
                    // {label: '外挂', value: 2},
                    {label: '其他', value: 3},
                ],
                status: -1,
                statusOptions: [
                    {label: '全部', value: -1},
                    {label: '未处理', value: 0},
                    {label: '已处理', value: 1},
                ],
				form:{
				    roomName:"",//牌局名称
				    duration:720,//牌局时长
				    minBring:0,//最小带入
				    maxBring:5000000,//最大带入
				    enableChat:"1",//是否开启聊天功能,默认开启
				    autoCreate:"1",//是否自动开启下一个房间,默认关闭
				},
                currentPage: 1,
                show: false,
                selection: [],
                complaintContent: '',//投诉内容
                content: '',// 回复内容
                idList: []
            }
        },
        computed: {
            ...mapState('system', ['cbRoomList']),
        },
        created() {
            this.getList()
        },
        filters: {
           
        },
        methods: {
            ...mapActions('system', ['getCbroomList', 'insertCbRoom','closeCbRoom',"editCbroom"]),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getCbroomList({
                    status: this.status,
                    page
                }).then(() => {
                    this.loading = false;
                })
            },
			edit(row){
                var self=this;
                if(row.autoCreate==1){
                    row.autoCreate=0;
                }else{
                    row.autoCreate=1;
                }
                this.editCbroom(row)
                    .then(res => {
                    //提交数据到vuex
                        if(res.code == 0){
                           this.$message.success(res.msg)
                             setTimeout(function() {
                                self.getList();
                            }, 1000);
                           
                        }else{
                           this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.msg)
                    });
            },
			subMitInsertPlan(){
			    if(this.form.roomName==null ||this.form.roomName==""){
					this.$message.error("请输入房间名称")
			        return;
			    }
			
			    this.insertCbRoom(this.form)
			        .then(res => {
			        //提交数据到vuex
			            if(res.code == 0){
			                this.dialogTableVisible=false;
			               this.$message.success(res.msg)
			                 this.getList();
			            }else{
							this.$message.error(res.msg)
			            }
			        })
			        .catch(err => {
			           this.$message.error(err.msg)
			        });
			},
			closeRoom(row,status){
			    var self=this;
			   this.$confirm('您确定执行此操作吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					  row.status=status;
					  this.closeCbRoom(row)
						  .then(res => {
						  //提交数据到vuex
							debugger
							  if(res.code == 0){
								this.$message.success(res.msg)
								   setTimeout(function() {
									  self.getList();
								  }, 1000);
								 
							  }else{
								this.$message.error(res.msg)
							  }
						  })
						  .catch(err => {
							this.$message.error(err.msg)
						  });
					
				  }).catch(() => {
					  this.$message.info("已取消删除")
				  });
			},
            detailFunc(rows) {
				
				console.log(rows);
                if (!rows.length) {
                    this.$message.error('请先选择您要回复的玩家');
                    return
                }
                if (rows.length === 1) {
                    this.complaintContent = rows[0].message;
                } else {
                    this.complaintContent = '';
                }
				
                this.idList = rows.map(item => item.userId);
                this.show = true;
            },
			roomStatusTr(val){//房间状态 0=未开始,1=开始,2=暂停,3=结束
			    if(val==0){
			        return "未开始";
			    }else if(val==1){
			        return "进行中";
			    }else if(val==2){
			        return "暂停中";
			    }else {
			        return "已结束";
			    }
			},
			getLocalTime(nS) {
			    if(nS==null){
			        return "";
			    }
			    //将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
			    let date = new Date(nS);
			    let year = date.getFullYear();
			    let month = date.getMonth()+1;
			    let day = date.getDate();
			    let hh = date.getHours();
			    let mm = date.getMinutes();
			    let ss = date.getSeconds();
			
			    month = month < 10 ? "0"+month:month;
			    day = day < 10 ? "0"+day:day;
			    hh = hh < 10 ? "0"+hh:hh;
			    mm = mm < 10 ? "0"+mm:mm;
			    ss = ss < 10 ? "0"+ss:ss;
			    date = year+'-'+month+'-'+day+" "+hh+":"+mm+":"+ss;
			    return date;
			},
			insertPlan(){
			    this.dialogTableVisible=true;
			},
			buttonType(row){
			     if (row.autoCreate ==0) {
			     return 'danger';
			     } 
			     return 'primary';
			 },
            submitFunc() {
				debugger
				let params ={
						sendToRandomIds:this.idList,
						sendType:2,
						pushSwitch:0,
						zhContent: this.content,// 简体
						hkContent: this.content,// 繁体
						usContent: this.content,// 英文
						sendTimeType:1,
						sentTime: '',
					};
                this.updateUserFeedback(params).then(() => {
                    this.show = false;
                    this.$message.success('请求成功');
                    this.getList(this.currentPage);
                })
            }
        }
    }
</script>

<style  scope>

	.el-slider__runway{
	    width: 240px;
	    float: right;
	}
	.custom-slider .el-slider__marks-text {
	    transform: translateY(-125%) translateX(-50%); /* 将标记移动到滑块上方 */
	    /* transform:translateX(-100%) tr; */
	    font-size: 12px; /* 减小文字大小 */
	    width: 40px;
	}
</style>